import { useTranslateErrors } from '@composables/useTranslateErrors';

export const useTranslatedErrors = (
    errors: ComputedRef<Partial<Record<string, string | string[] | undefined>>>
) => {
    const { translateErrorsObject, joinTranslatedErrorsObject } =
        useTranslateErrors();

    // This is not performant but I faced an issue after I had tried
    // to use yup's setLocale method in onLanguageSwitched hook.
    // Unfortunately, the error messages did not update after changing the locale.
    const translatedErrors = computed(() => {
        const translatedErrorsObject = translateErrorsObject(errors.value);
        return joinTranslatedErrorsObject(translatedErrorsObject);
    });

    return {
        translatedErrors,
    };
};
